import { render, staticRenderFns } from "./BillingColumns.vue?vue&type=template&id=29c304e0"
import script from "./BillingColumns.vue?vue&type=script&lang=js"
export * from "./BillingColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports